import PropTypes from 'prop-types';
import BaseSelectorReadonlyToInput from "../../component/Select/BaseSelectorReadonlyToInput";
import MovementOrderService from "../MovementOrderService";

class MovementOrderSelector extends BaseSelectorReadonlyToInput {

  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      title: 'Ordem de Movimentação',
      label: 'code',
      value: 'id',
      url: MovementOrderService.ALL_URL
    };
  }
}

MovementOrderSelector.propTypes = {
  required: PropTypes.bool,
  setValue: PropTypes.func,
  defaultValue: PropTypes.string,
  readonly: PropTypes.bool,
  onChange: PropTypes.func,
};

export default MovementOrderSelector;



// WEBPACK FOOTER //
// ./src/movementOrder/component/MovementOrderSelector.js